module.exports = __webpack_public_path__ + "static/img/character1.0e3b52f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/character1.svg
// module id = v/eZ
// module chunks = 11